module.exports = __webpack_public_path__ + "img/shenzhou.1dca973b.png";